import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { API_BASE_URL, getBearerToken } from '../../functions';
import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
import ToastMessage from '../ToastMessage';

const AddButton = ({ show, setShow, editData }) => {
    const handleClose = () => setShow(false);
    const [toastMessage, setToastMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    // const Navigate = useNavigate()
    const [editMode, setEditMode] = useState(false);
    const [dashbtn, setDashbtn] = useState();




    const [data, setData] = useState({
        target: '',
        title: '',
        image: null,
    });

    useEffect(() => {
        axios.get(`${API_BASE_URL}/${'list-of-dashbtn'}`, {
            headers: {
                'Authorization': `Bearer ${getBearerToken()}`
            }
        }).then(response => {
            // Handle the response data

            setDashbtn(response?.data?.data.data)
        }).then(result => {
            // Handle the response data
            // console.log(result);
        })
            .catch(error => {
                // Handle errors
                // console.log('error', error);
            });
    }, [])
    useEffect(() => {
        // If editData is provided, update the data state with the editData
        if (editData) {
            setData({ ...editData });
            setEditMode(true);
        } else {
            // If editData is not provided, reset the data state for adding a new 
            setData({
                target: '',
                title: '',
                image: null,
            });
            setEditMode(false);
        }
    }, [editData]);

    const handleSubmit = (e) => {
        e.preventDefault()
        setLoading(true)

        const formData = new FormData();

        formData.append('title', data.title)
        formData.append('target', data.target)
        formData.append('image', data.image)

        if (editMode) {
            // Update an existing airline
            // Assuming editData contains the ID of the airline to be updated
            axios
                .post(`${API_BASE_URL}/update-Button/${editData.id}`, formData, {
                    headers: {
                        'Authorization': `Bearer ${getBearerToken()}`
                    }
                })
                .then((response) => {
                    setToastMessage({ type: 'success', message: 'updated successfully!', show: 'show' });
                    setLoading(false);
                    handleClose();
                    // window.location.reload();
                })
                .catch((error) => {
                    setToastMessage({ type: 'error', message: error });
                    setLoading(false);
                });
        } else {
            // Add a new airline
            axios
                .post(`${API_BASE_URL}/add-button`, formData, {
                    headers: {
                        'Authorization': `Bearer ${getBearerToken()}`
                    }
                })
                .then((response) => {
                    setToastMessage({ type: 'success', message: 'added successfully!', show: 'show' });
                    setLoading(false)
                    handleClose()
                    // window.location.reload()
                })
                .catch((error) => {
                    setToastMessage({ type: 'error', message: error });
                    setLoading(false)
                });
        }
    };


    console.log("dasdsadsadsa", data);
    return (
        <>
            {toastMessage && <ToastMessage type={toastMessage.type} message={toastMessage.message} show={toastMessage.show} />}
            <Modal show={show} size="lg" onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false}>
                <Form className={'AllForm'} onSubmit={handleSubmit}>

                    <Modal.Header closeButton className="d-flex px-4 align-items-center">
                        <Modal.Title id="contained-modal-title-vcenter">{editMode ? 'Edit' : 'Add'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-4">
                        {/*  */}
                        <Row className={'my-4'}>
                            <Col className={'mb-4'} xl={'6'} lg={'6'}>
                                <Form.Group className="form-group" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Title *</Form.Label>
                                    <Form.Control required type="text" name={''} id={''} placeholder={'Title'} onChange={(e) => setData({ ...data, title: e.target.value })} value={data?.title} />
                                </Form.Group>
                            </Col>
                            <Col className={'mb-4'} xl={'6'} lg={'6'}>
                                <Form.Group className="form-group" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Target *</Form.Label>
                                    <Form.Control required type="text" name={''} id={''} placeholder={'Target'} onChange={(e) => setData({ ...data, target: e.target.value })} value={data?.target} />
                                </Form.Group>
                            </Col>
                            <Col className={'mb-4'} xl={'12'} lg={'12'}>
                                <Form.Group className="form-group" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Image *</Form.Label>
                                    {!(data?.image === editData?.image) ?
                                        <Form.Control
                                            required={!editData?.image} // Mark as required only when adding a new agent
                                            type="file"
                                            name={''}
                                            id={''}
                                            placeholder={'Image'}
                                            onChange={(e) => setData({ ...data, image: e.target.files[0] })}
                                        />
                                        :
                                        <div className="d-flex align-items-center">
                                            <img src={data?.image} alt="Image" width="100" height="100" className="me-2" />
                                            <Button variant="outline-danger" size="sm" onClick={() => setData({ ...data, image: null })}>
                                                Remove Image
                                            </Button>
                                            {/* // Check if data.image is falsy (no image is present) */}

                                        </div>
                                    }
                                </Form.Group>
                            </Col>
                        </Row>

                    </Modal.Body>
                    {/*  */}
                    <Modal.Footer className="">
                        <Button variant="" className="w-100px F1F1F1bg fontsize14 fontweight700 me-3" onClick={handleClose}>Cancel</Button>
                        <Button variant="" disabled={loading} type='submit' className="w-100px text-white fontweight700 fontsize14 brandMainColorBg">
                            {loading ?
                                <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />
                                : editMode ? 'Update' : 'Save'
                            }
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

export default AddButton;